import { LanguageObject } from '@/i18n';
import axios from 'axios';
import { User } from './UserUtils';

interface Notification {
  id: number;
  name: string;
  text: LanguageObject;
  datepublished: string;
}

interface NotificationAssoc {
  notification: Partial<Notification>;
  user: Partial<User>;
  read: boolean;
  dateread: string;
}

const api = {
  list: async (params?: any) => {
    const resp = await axios.get<Notification[]>('/notifications/list.php', {
      params: params,
    });
    return resp.data;
  },

  get: async (id: number) => {
    const resp = await axios.get<Notification>('/notifications/get.php', {
      params: { id: id },
    });
    return resp.data;
  },

  add: async (notification: Partial<Notification>) => {
    const resp = await axios.post<Notification>(
      '/notifications/add.php',
      notification
    );
    return resp.data;
  },

  update: async (notification: Partial<Notification>) => {
    const resp = await axios.post<Notification>(
      '/notifications/update.php',
      notification
    );
    return resp.data;
  },

  remove: async (id: number) => {
    await axios.delete('/notifications/delete.php', {
      params: { id: id },
    });
  },

  publish: async (id: number) => {
    await axios.get<Notification>('/notifications/publish.php', {
      params: { id: id },
    });
  },
};

export default {
  api,
};

export { Notification, NotificationAssoc };
